<template>
  <div id="question">
    <div class="deviceAddBlock">
      <div class="control-tips">
        <p>{{$t("control_tips")}}</p>
        <div>
          {{$t("question_tips_1")}}
          <br />
          {{$t("question_tips_2")}}
          <br />
          {{$t("question_tips_3")}}
          <br />
        </div>
      </div>
      
      <el-form id="deviceAdd" ref="deviceAdd" size="small" label-position="top">
        <div class="setname"></div>
        <el-select v-if="configType==2" @change="getList" size="small" v-model="code">
        <el-option :label="$i18n.t("buchong").alldevice" value="-1">{{$t("buchong").alldevice}}</el-option>
          <el-option
            v-for="option in deviceLists"
            :label="option.code"
            :key="option.code"
            :value="option.code"
          >{{option.code}}</el-option>
        </el-select>
        <div class="setname">{{$t("customer_label")}}</div>
        <el-radio-group v-model="customer_info">
          <el-radio label="1">{{$t("open")}}</el-radio>
          <el-radio label="-1">{{$t("close")}}</el-radio>
        </el-radio-group>
        <br />
        <br />
        <p>*{{$t("customer_tips")}}</p>
        <span @click="dialogCustomerShow=true" class="scan">{{$t("check_message")}}</span>
        <div style="margin-bottom:30px; width:500px;" class="outline"></div>

        <div class="setname">{{$t("question_label")}}</div>
        <el-radio-group v-model="have_questions">
          <el-radio label="1">{{$t("open")}}</el-radio>
          <el-radio label="-1">{{$t("close")}}</el-radio>
        </el-radio-group>
        <br />
        <br />
        <p>*{{$t("question_tips")}}</p>
        <span @click="dialogQuestionShow=true" class="scan">{{$t("check_question")}}</span>
        <div style="width:500px;" class="outline"></div>

        <el-button size="small" class="btn1" type="primary" @click="submit">{{$t("normal_sure")}}</el-button>
      </el-form>
    </div>
    <el-dialog :title="$i18n.t('buchong').customer" width="30%" :visible.sync="dialogCustomerShow">
      <el-form>
        <el-form-item :label="$i18n.t('support_username')" :label-width="formLabelWidth">
          <el-input disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('support_mobile')" :label-width="formLabelWidth">
          <el-input disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$i18n.t('sex_name')" :label-width="formLabelWidth">
          <el-radio-group>
            <el-radio disabled="disabled" label="1">{{$t("sex")[0]}}</el-radio>
            <el-radio disabled="disabled" label="2">{{$t("sex")[1]}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$i18n.t('age_name')" :label-width="formLabelWidth">
          <el-input disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      top="1vh"
      :lock-scroll="true"
      :title="$i18n.t('check_question')"
      width="70%"
      :visible.sync="dialogQuestionShow"
    >
      <div v-for="(item, index) in list" :key="index">
        <div class="question">
          <div class="title">{{index+1}}. {{item.question}}</div>
          <input v-if="item.type == 3" :placeholder="item.placeholder" class="input-text" />
          <ol v-else>
            <li v-for="(option, opIndex) in item.options" :key="opIndex">
              <label>
                <span><i></i></span>
                <p>{{option.option}}</p>
              </label>
            </li>
          </ol>
        </div>
        <div class="line" v-if="index<list.length-1"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "question",
  data() {
    return {
      customer_info: "1",
      have_questions: "1",
      doing: false,
      dialogCustomerShow: false,
      formLabelWidth: "90px",
      dialogQuestionShow: false,
      list: null,
      deviceLists: null,
      configType: '1',
      code: '-1'
    };
  },
  computed: {},
  created() {
    // this.getUserInfo()
    // this.loadQuestions();
  },
  methods: {
    loadQuestions() {
      let _this = this;
      // this.axios.get("/skinmgr/question/list").then(function(res) {
      //   if (res.data.code == 0) {
      //     _this.list = res.data.list;
      //   }
      // });
    },
    getDevice () {
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = {'is_set_work': 1}
      console.log(data)
      this.axios.post('/skinmgr/device/list', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.deviceLists = response.data.data.list
          _this.code = "-1";
          _this.getList();
        }
        console.log(response.data)
      })
    },
    getList() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        code: this.code
      };
      this.axios
        .post("/skinmgr/config/match", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.customer_info =
              parseInt(response.data.data.customer_info) < 1
                ? "-1"
                : response.data.data.customer_info;
            _this.have_questions =
              parseInt(response.data.data.have_questions) < 1
                ? "-1"
                : response.data.data.have_questions;
          }
        });
    },
    submit() {
      if (this.doing === true) {
        return false;
      }
      this.doing = true;
      let _this = this;
      let data = {
        customer_info: this.customer_info,
        have_questions: this.have_questions,
        code: this.code
      };
      this.axios
        .post("/skinmgr/config/editMatch", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code === 0) {
            _this.$message(_this.$i18n.t("setsuccess"));
          }
        });
    },
    getUserInfo() {
      var _this = this;
      // this.axios.get("/skinmgr/config/userInfo").then(function(res) {
      //   if (res.data.code == 0) {
      //     _this.configType = res.data.manager_type;
      //     if (_this.configType === 1) {
      //       //极简风格无设备
      //       _this.code = "-1";
      //       _this.getList();
      //     } else {
      //       _this.getDevice();
      //     }
      //   }
      // });
    }
  }
};
</script>
<style  lang="scss">
#question {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-dialog__header {
    border-bottom: #e9e9e9 1px solid !important;
  }
  .el-button--primary {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #57AEC9;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #57AEC9;
    background: #57AEC9;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border: none;
    color: #333;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
  }
}
</style>

<style scoped lang="scss">
#question {
  box-sizing: border-box;
  margin: 0.1667rem;
  div.control-tips {
    border-radius: 0.04166rem;
    height: 0.6833rem;
    color: #57AEC9;
    font-size: 14px;
    padding: 0.1667rem;
    width: calc(100% - 0.64rem);
    background-color: #fff;
    border: 1px solid #ffcee5;
    margin: 0.1667rem;
  }
  div.control-tips p {
    font-size: 0.116rem;
  }
  div.control-tips div {
    font-size: 0.116rem;
    margin: 0.0833rem 0;
    line-height: 160%;
  }
  .deviceAddBlock {
    min-height: 2.667rem;
    height: auto;
    border-radius: 0.04166rem;
    display: block;
    margin-top: 0.0833rem;
    padding: 0.0833rem;
    background-color: #fff;
    width: calc(100% - 0.1667rem);
    #deviceAdd {
      width: calc(100% - 0.1667rem);
      margin: 0.32rem 1.2rem;
      p {
        font-size: 0.116rem;
        color: #ccc;
        margin-top: 0.166rem;
      }
      .outline {
        margin-top: 0.116rem;
        width: calc(100% - 1.2rem);
        height: 1px;
        border-top: 1px solid #ccc;
      }
    }
  }
  .btn1 {
    margin-top: 0.1667rem;
    width: 1rem;
    height: 0.33rem;
    font-size: 0.12rem;
  }
  .setname {
    font-size: 0.14rem;
    color: #333;
    left: -1.4rem;
    margin-right: 0.4rem;
    top: 0.15rem;
    position: relative;
    width: 1.2rem;
    text-align: right;
    display: block;
  }
  .scan {
    color: #409eff;
    font-size: 14px;
    border: 1px solid #409eff;
    display: block;
    width: 1rem;
    height: 0.22rem;
    text-align: center;
    line-height: 0.22rem;
    margin-top: 0.1rem;
    cursor: pointer;
  }
  .question {
    width: calc(100% - 0.6rem);
    margin-top: 0.1rem;
    margin-left: 0.3rem;
  }
  .question .title {
    font-size: 0.17rem;
    color: #000000;
    font-weight: bold;
  }
  .question .check1 {
    color: #000000;
    display: block;
    margin-top: 0.1rem;
    width: 95%;
  }
  .question p {
    font-size: 0.09rem;
    color: #000000;
    display: inline-block;
    width: 80%;
    margin-left: 0.02rem;
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: top;
  }

  .question .check2 {
    color: #000000;
    display: inline-block;
    margin-top: 0.1rem;
    width: 31%;
  }

  .question label span {
    border: 0.01rem solid #aeaeae;
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    margin-top: 0.02rem;
  }

  .question label i {
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    position: absolute;
  }

  .question label .choose {
    border: 0.01rem solid #ffffff;
    width: 0.12rem;
    height: 0.12rem;
    border-radius: 50%;
    display: inline-block;
    margin-top: 0.02rem;
  }

  .question label .choose i {
    //background-image: url(assets/image/ic-radio-checked.png);
    background-position: center;
    background-size: cover;
    display: inline-block;
    width: 0.13rem;
    height: 0.13rem;
    border-radius: 50%;
    position: absolute;
  }
  .line {
    background-color: #d8d8d8;
    width: 90%;
    height: 0.01rem;
    margin-top: 0.2rem;
    margin-left: auto;
    margin-right: auto;
  }

  .question .input-text {
    -webkit-appearance: none;
    background-color: #f2f2f2;
    border: none;
    color: #000000;
    display: inline-block;
    height: 0.4rem;
    line-height: 0.4rem;
    outline: 0;
    width: calc(90%);
    font-size: 0.18rem;
    padding-left: 0.23rem;
    margin-top: 0.1rem;
  }
  .question .input-submit {
    border-radius: 0.18rem;
    height: 0.36rem;
    width: 100%;
    font-size: 0.17rem;
    color: black;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
    background: #ff3a80;
    color: #ffffff;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/sell/question.vue